import { EPermissoes } from '@/enums/ePermissoes';

/**
 * Painéis de gestão do gabarito (public/paineis-gestao): menu lateral, busca, favoritos e visões
 * salvas ficam no gabarito, que roda na rota /paineis (PaineisHost.vue). `id` é a rota do painel no
 * gabarito (#id) e o mesmo id do manifesto; a ordem é a do manifesto.
 * Cada painel exige a permissão da consulta principal dele (a API refaz a checagem no GraphQL).
 */
export const PAINEIS_GABARITO = [
  { id: 'executivo', nome: 'Painel Executivo', rota: 'DashboardExecutivo', permissao: EPermissoes.Relatorio },
  { id: 'concreteiras', nome: 'Desempenho das Concreteiras', rota: 'DashboardConcreteiras', permissao: EPermissoes.Relatorio },
  { id: 'desvio-padrao', nome: 'Desvio-padrão e Altas Resistências', rota: 'DashboardDesvioPadrao', permissao: EPermissoes.Relatorio },
  { id: 'timeline-concretagem', nome: 'Timeline de Concretagem', rota: 'DashboardTimelineConcretagem', permissao: EPermissoes.Relatorio },
  { id: 'atrasos-hora-extra', nome: 'Atrasos, Duração e Hora Extra', rota: 'DashboardAtrasosHoraExtra', permissao: EPermissoes.Relatorio },
  // NCs vêm de mtvNCoNaoConformidade, que exige a permissão do relatório de não conformidade.
  { id: 'nao-conformidades', nome: 'Não Conformidades', rota: 'DashboardNaoConformidades', permissao: EPermissoes.Relatorio_NaoConformidadeQualidade }
];

export type PainelGabarito = (typeof PAINEIS_GABARITO)[number];

/** Meta de rota de um painel: a mesma regra do guard do router, usada para filtrar o menu do gabarito. */
export const metaDoPainel = (p: PainelGabarito) => ({
  requiresAuth: true,
  utlTipoFornecimentoId: 1,
  permissions: [p.permissao]
});

/** Endereço do painel no sistema (o gabarito abre direto nele). */
export const rotaDoPainel = (id: string) => `/paineis#${id}`;
